import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON, apiRootEndpoint } from '../../helpers';
import {
    GET_CATEGORIES, 
    SUBMIT_CATEGORY_FORM,
    DELETE_CATEGORY
} from '../../constants/actionTypes';


import {
    getAllCategoriesSuccess,
    getAllCategoriesFailed,

    submitCategoryFormSuccess,
    submitCategoryFormFailed,

    deleteCategorySuccess,
    deleteCategoryFailed,
} from './actions';

const apiUrl = `${apiRootEndpoint}/api/v1/portal/categories`;

function* getAllCategories({ payload: { offset, limit } }) {
    const options = {
        method: 'GET',
    };

    try {
        const url = `${apiUrl}?offset=${offset}&limit=${limit}`;
        const {total, data} = yield call(fetchJSON, url, options);
        yield put(getAllCategoriesSuccess({total, data}));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(getAllCategoriesFailed(message));
    }
}

function* submitCategory({ payload: category }) {
    const options = {
        body: JSON.stringify(category),
        method: category.id ? 'PUT' :  'POST',
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        let url = `${apiUrl}`;
        if(category.id) {
            url = `${apiUrl}/${category.id}`;
        }
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(submitCategoryFormSuccess(response.data));
        }
        else {
            yield put(submitCategoryFormFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(submitCategoryFormFailed(message));
    }
}

function* deleteCategory({ payload: id }) {
    const options = {
        method: 'DELETE',
    };
    try {
        const url = `${apiUrl}/${id}`;
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(deleteCategorySuccess(id));
        }
        else {
            yield put(deleteCategoryFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(deleteCategoryFailed(message));
    }
}


export function* watchGetAllCategories() {
    yield takeEvery(GET_CATEGORIES, getAllCategories);
}
export function* watchSubmitCategoryForm() {
    yield takeEvery(SUBMIT_CATEGORY_FORM, submitCategory);
}
export function* watchDeleteCategory() {
    yield takeEvery(DELETE_CATEGORY, deleteCategory);
}

function* serviceSaga() {
    yield all([
        fork(watchGetAllCategories),
        fork(watchSubmitCategoryForm),
        fork(watchDeleteCategory),
    ]);
}

export default serviceSaga;